import { render, staticRenderFns } from "./SlideBanner.vue?vue&type=template&id=7797d052"
import script from "./SlideBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideBanner.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
